




































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import dayjs from "dayjs";

@Component
export default class DatePickerCalendar extends Vue {
  @Prop({ default: () => [] }) readonly dataRequired!: any | null;
  @Prop({ default: "" }) readonly dataInitialize!: string;
  @Prop() loading!: boolean;

  data = "";
  dataInput = "";
  menu = false;

  @Watch("data")
  onDateChange(val: string) {
    this.$emit("input", val);
  }

  @Watch("dataInitialize")
  onDataInitialize(val: string) {
    this.data = val;
  }

  formatData() {
    this.data = dayjs(this.dataInput).format("DD/MM/YYYY");
  }
}
